import styled, { css } from 'styled-components';
import { Layout as AntdLayout } from 'antd';

export const Wrapper = styled(AntdLayout)`
  height: 100vh;
  width: 100vw;
  background: transparent;
  overflow-y: hidden;
  background: url('/images/boarding.svg') no-repeat center center fixed;
  background-size: cover;

  @media print {
    height: auto;
    overflow: visible;
  }
`;

export const DarkModeOverlay = styled.div<{
  $darkMode?: boolean;
  $404?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.black};
  opacity: ${({ $darkMode }) => ($darkMode ? 0.5 : 0)};
  transition: opacity 0.25s ease-in-out;
  pointer-events: none;
  z-index: ${({ $404 }) => ($404 ? 1000 : 'unset')};
`;

/* 
Without 'width: <N>px' border of layout becomes hidden when size changed 
You could test it if add style 'border: 3px solid red;'
*/
export const Layout = styled.div<{ $overflowY?: 'auto' }>`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 650px;

  ${({ $overflowY }) =>
    $overflowY &&
    css`
      overflow-y: ${$overflowY};
    `}
`;
